export enum AgoraRoleTypes {
    Audience = "audience",
    Host = "host"
}
